import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const JaFlag = createIcon({
  displayName: 'JaFlag',
  viewBox: '0 0 900 600',
  path: [
    <svg height="600" key="JaFlag" width="900">
      <rect fill="#333" height="600" width="900" />
      <rect fill="#fff" height="590" width="890" x="5" y="5" />
      <circle cx="450" cy="300" fill="#bc002d" r="180" />
    </svg>,
  ],
})
